import { useMemo } from 'react'
import { useWalletClient } from 'wagmi'
import { zkSync } from 'wagmi/chains'

export function useEthersProvider({ chainId = zkSync.id }: { chainId?: number } = {}) {
  const { data: walletClient } = useWalletClient({ chainId })
  return useMemo(() => {
    if (walletClient) {
      return walletClient.transport // EIP-1193 provider here
    }
    return undefined
  }, [walletClient])
}
